import angular from 'angular';

let whenScrolledModule = angular.module('shared.components.whenScrolled',[])
  .directive('whenScrolled', whenScrolled);

function whenScrolled(){

}

whenScrolled.$inject = [];
export default whenScrolledModule;



/** WEBPACK FOOTER **
 ** ./www/components/shared/components/when-scrolled/when-scrolled.js
 **/